/**
 * Resolves as `promise` does, or with `fallback` once `ms` have passed
 * without it settling. A rejection still rejects.
 */
export function withTimeout<T, F = undefined>(promise: Promise<T>, ms: number, fallback?: F): Promise<T | F> {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => resolve(fallback as F), ms);
        promise.then(
            value => {
                clearTimeout(timer);
                resolve(value);
            },
            error => {
                clearTimeout(timer);
                reject(error);
            }
        );
    });
}
